import React, { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { throttle, get } from "lodash";

import DesktopHeader from "./desktop";
import MobileHeader from "./mobile";
import StickyBanner from "../../molecules/sticky-banner";
import { getUserDetails, addTokensToLocalStorage } from "../../helper/utils";
import ElectionFloatingWidget from "../../atoms/election-floating-widget";
import CricketWidget from "../../molecules/cricket-widget";
import { createScrollHandler } from "../header/useScrollBehavior.js";

import {
  setIsLoading,
  setIsLogin,
  setMakeSecondaryApiCallsTriggered,
  setNewNotification,
  setNotificationList,
  setUserDetails
} from "../../store/actions";
import { GoogleOAuthProvider, googleLogout } from "@react-oauth/google";

import GoogleOneTapSignInUp from "../../atoms/google-one-tap";
import { addAuthTrackingToDataLayer, addSignUpLoginToDataLayer, pushPageDataLayer } from "../../helper/datalayer-utils";

// Common wrapper for navigation. We could add OffcanvasMenu, Navbar etc components here.
// const hardcodeHeaderURLs = ["/cuisines-of-karnataka", "/media-gallery-new", "/cok-reciepes"];
const Header = () => {
  const dispatch = useDispatch();

  const pageType = useSelector((state) => get(state, ["qt", "pageType"]));
  const pageData = useSelector((state) => get(state, ["qt", "data"], []));

  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const makeSecondaryApiCallsDelay = 2250;
  const [makeSecondaryApiCalls, setMakeSecondaryApiCalls] = useState(false);
  const [isMobile, setMobile] = useState(true);
  // const [isHardcodedHeader, setIsHardcodedHeader] = useState(false);
  const [loadOneTap, setGoogleOneTap] = useState(false);
  const GoogleClientId = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "google_client_id"], "")
  );


  const [showStickyNavbar, setShowStickyNavbar] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState("up");
  const [showPrimaryHeader, setShowPrimaryHeader] = useState(true);
  const [showSecondaryHeader, setShowSecondaryHeader] = useState(true);
  const [showAdBanner, setShowAdBanner] = useState(false);
  const [adClosed, setAdClosed] = useState(false);
  const [showDesktopSecondaryHeader, setShowDesktopSecondaryHeader] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const user = window?.localStorage?.getItem("user");
      if (user && user !== "undefined") {
        try {
          const parsedUser = JSON.parse(user);
          if (parsedUser) {
            addAuthTrackingToDataLayer(parsedUser);
          }
        } catch (e) {
          console.error("Invalid user data in localStorage", e);
        }
      }
    }
  }, []);
  const isHardcodedHeader = useMemo(() => {
    if (
      (pageType === "section-page" || pageType === "sub-section-page") &&
      pageData?.collection?.metadata?.["custom-header"] === "cok2025"
    ) {
      return "cok2025";
    }
    return null;
  }, [pageType, pageData]);

  const getScroll = createScrollHandler({
    lastScrollY,
    makeSecondaryApiCalls,
    adClosed,
    setMakeSecondaryApiCalls,
    setShowPrimaryHeader,
    setShowSecondaryHeader,
    setShowAdBanner,
    setShowStickyNavbar,
    setShowDesktopSecondaryHeader,
    setScrollDirection,
    setLastScrollY,
    showPrimaryHeader,
    showSecondaryHeader,
    showAdBanner,
    showStickyNavbar,
    showDesktopSecondaryHeader
  });

  useEffect(() => {
    if (window && window?.innerWidth < 1025) {
      setMobile(true);
    } else {
      setMobile(false);
      setMakeSecondaryApiCalls(true);
    }

    if (window) {
      let searchQuery = window?.location?.search;
      let accessTokenIndex = searchQuery?.indexOf("?access_token");
      let output = accessTokenIndex !== -1 ? searchQuery?.substring(accessTokenIndex) : searchQuery;
      const searchParams = new URLSearchParams(output);
      const access_token = searchParams?.get("access_token");
      const refresh_token = searchParams?.get("refresh_token");
      const userLocalStorage = localStorage?.getItem("user");
      const stored_access_token = localStorage?.getItem("access_token");
      const stored_refresh_token = localStorage?.getItem("refresh_token");

      if (stored_refresh_token && stored_access_token) {
        dispatch(setIsLogin(true));
      }
      if (access_token && refresh_token) {
        addTokensToLocalStorage(access_token, refresh_token);
        getUserDetails()
          .then((data) => {
            if (data?.status === 401) {
              // Remove an tokens from localStorage
              localStorage?.removeItem("access_token");
              localStorage?.removeItem("refresh_token");
              localStorage?.removeItem("user");
              localStorage?.removeItem("commentsToken");

              googleLogout();
              //loggingout user if refresh token expires
              window.location.href = `${ssoEndpoint}/auth/logout?redirectUrl=${window.location.href.split("?")[0]}`;
            } else {
              dispatch(setIsLogin(true));
              dispatch(setUserDetails(data || {}));
              localStorage.setItem("user", JSON.stringify(data));
              const searchParam = accessTokenIndex !== -1 ? searchQuery.substring(0, accessTokenIndex) : searchQuery;
              window.history.replaceState({}, "", window.location.pathname + searchParam);

              addSignUpLoginToDataLayer(window.location.href, data);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (userLocalStorage && userLocalStorage !== "undefined" && userdetails?.userData === undefined) {
        if (typeof userLocalStorage === "string" && userLocalStorage?.trim() !== "") {
          dispatch(setUserDetails(JSON?.parse(userLocalStorage)));
        }
      } else {
        setGoogleOneTap(true);
      }
    }
  }, []);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          getScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [adClosed, lastScrollY, makeSecondaryApiCalls, showPrimaryHeader, showSecondaryHeader, showAdBanner, showStickyNavbar, showDesktopSecondaryHeader]);

  useEffect(() => {
    makeSecondaryApiCalls &&
      dispatch(setMakeSecondaryApiCallsTriggered(makeSecondaryApiCalls, makeSecondaryApiCallsDelay, isMobile));
  }, [makeSecondaryApiCalls]);

  useEffect(() => {
    _izq.push([
      "getNotificationFeed",
      function (response) {
        if (response?.response !== "success") {
          dispatch(setIsLoading(true));
        } else {
          dispatch(setIsLoading(false));
          dispatch(setNotificationList(response.data));
          const latestNotificationCreatedAt = window?.localStorage?.getItem("latestNotificationCreatedAt");

          if (response.data[0]?.createdAt !== latestNotificationCreatedAt || latestNotificationCreatedAt == null) {
            dispatch(setNewNotification(true));
          } else {
            dispatch(setNewNotification(false));
          }
        }
      }
    ]);
  }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    let changed = false;
    const utmMedium = params.get("utm_medium");

    if (utmMedium === "brick-wall" || utmMedium === "floatingwidget") {
      params.delete("utm_medium");
      params.delete("utm_campaign");
      changed = true;
    }
    if (changed) {
      const newUrl = url.pathname + (params.toString() ? `?${params.toString()}` : "") + url.hash;
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  const dataLayerPushedRef = useRef(false);

  useEffect(() => {
    dataLayerPushedRef.current = false;
  }, [pageType]);

  useEffect(() => {
    if (pageType && !dataLayerPushedRef.current) {
      const timer = setTimeout(() => {
        if (!dataLayerPushedRef.current) {
          pushPageDataLayer(pageType, userdetails, pageData);
          dataLayerPushedRef.current = true;
        }
      }, 100); // Reduced timeout since we now read from localStorage directly

      return () => clearTimeout(timer);
    }
  }, [pageType, pageData]);

  //  useEffect(() => {
  //   if (typeof document !== "undefined" && typeof window !== "undefined") {
  //     // Skip padding for custom headers - they handle their own spacing
  //     if (isHardcodedHeader) {
  //       document.body.style.paddingTop = "0px";
  //       document.body.style.paddingBottom = "0px";
  //       return;
  //     }

  //     const isMobileView = window.innerWidth < 769;
  //     if (isMobileView) {
  //       // Always reserve space for bottom elements to prevent CLS
  //       // This space is reserved whether elements are visible or not
  //       let bottomPadding = 0;
  //       if (showStickyNavbar && showAdBanner) {
  //         bottomPadding = 120; // navbar + banner
  //       } else if (showStickyNavbar) {
  //         bottomPadding = 52; // navbar only
  //       } else if (showAdBanner) {
  //         bottomPadding = 68; // banner only
  //       } else {
  //         bottomPadding = 0; // nothing visible
  //       }
  //       document.body.style.paddingBottom = `${bottomPadding}px`;

  //       // Reserve space for top headers
  //       let topPadding = 0;
  //       if (showPrimaryHeader && showSecondaryHeader) {
  //         topPadding = 83;
  //       } else if (showSecondaryHeader) {
  //         topPadding = 36;
  //       } else {
  //         topPadding = 0;
  //       }
  //       document.body.style.paddingTop = `${topPadding}px`;
  //     } else {
  //       document.body.style.paddingBottom = "0px";
  //       let desktopTopPadding = 75;
  //       if (showDesktopSecondaryHeader) {
  //         desktopTopPadding += 46;
  //       }
  //       document.body.style.paddingTop = `${desktopTopPadding}px`;
  //     }
  //   }
  //   return () => {
  //     if (typeof document !== "undefined") {
  //       document.body.style.paddingBottom = "0px";
  //       document.body.style.paddingTop = "0px";
  //       document.body.style.transition = "";
  //     }
  //   };
  // }, [showStickyNavbar, showPrimaryHeader, showSecondaryHeader, showDesktopSecondaryHeader, showAdBanner, isHardcodedHeader]);

  return (
    <GoogleOAuthProvider clientId={GoogleClientId}>
      {loadOneTap && <GoogleOneTapSignInUp />}
      {!isMobile ? (
        <div className="header-hide-tab">
          <DesktopHeader isHardcodedHeader={isHardcodedHeader} showSecondaryHeader={showDesktopSecondaryHeader} />
        </div>
      ) : (
        <div className="header-hide-dektop">
          <MobileHeader isHardcodedHeader={isHardcodedHeader}
          showPrimaryHeader={showPrimaryHeader}
          showSecondaryHeader={showSecondaryHeader}
          showStickyNavbar={showStickyNavbar} />
        </div>
      )}
      <StickyBanner isVisible={showAdBanner} showStickyNavbar={showStickyNavbar} />
      <ElectionFloatingWidget />
      <CricketWidget />
    </GoogleOAuthProvider>
  );
};

export { Header };
